export default __webpack_public_path__ + "static/media/edit-employee.0ac835f4.svg";